export default __webpack_public_path__ + "static/media/logo_tech.88f50dc2.png";